import {
  DialogHeader,
  DialogTitle,
  DialogDescription,
  Badge,
} from '@/components/ui'
import type { MenuItem } from '@/types/menu'

interface ItemHeaderProps {
  item: MenuItem
}

export function ItemHeader({ item }: ItemHeaderProps) {
  return (
    <DialogHeader>
      <DialogTitle className="text-2xl font-bold">{item.name}</DialogTitle>
      <DialogDescription className="text-base">
        {item.description}
      </DialogDescription>

      {/* Badges */}
      <div className="flex gap-2 flex-wrap pt-1">
        <Badge variant="outline">{item.category}</Badge>
        {item.itemType === 'combo' && (
          <Badge className="bg-primary text-primary-foreground hover:bg-primary/90">Combo</Badge>
        )}
        {item.isPopular && <Badge variant="secondary">Popular</Badge>}
        {item.foodTypes?.map((type) => (
          <Badge key={type} variant="secondary" className="text-xs">
            {type}
          </Badge>
        ))}
      </div>

      {/* Allergens & Nutrition */}
      {(item.allergens?.length || item.nutritionInfo) && (
        <div className="space-y-2 pt-2 text-sm">
          {item.allergens && item.allergens.length > 0 && (
            <div className="text-muted-foreground">
              <strong>Allergens:</strong> {item.allergens.join(', ')}
            </div>
          )}
          {item.nutritionInfo && (
            <div className="text-xs bg-muted/50 p-2.5 rounded-lg">
              <strong>Nutrition:</strong> {item.nutritionInfo.calories} cal ·{' '}
              {item.nutritionInfo.protein}g protein ·{' '}
              {item.nutritionInfo.carbs}g carbs · {item.nutritionInfo.fat}g fat
            </div>
          )}
        </div>
      )}
    </DialogHeader>
  )
}
